import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { IUser } from "@faire/web-api--source/indigofair/data/IUser";

import { getBrandToken } from "./getBrand";
import { getRetailerToken } from "./getRetailer";

export const getUser = (): IUser | undefined => {
  return getGlobalProperty("user");
};

export const getIsLoggedInUser = (): boolean => {
  const retailerToken = getRetailerToken();
  const brandToken = getBrandToken();
  return !!retailerToken || !!brandToken;
};

export const getUserToken = (): string | undefined => {
  return getUser()?.token;
};

export const getUserEmail = (): string => {
  const user = getUser();
  return user?.email_address ?? user?.additional_email_address ?? "";
};

export const getUserFullName = (): string => {
  const user = getUser();

  return user
    ? `${user?.first_name?.trim() ?? ""} ${
        user?.last_name?.trim() ?? ""
      }`.trim()
    : "";
};

export const getUserPhoneNumber = (): string => {
  const user = getUser();
  return user?.phone_number ?? "";
};

export const getUserType = (): keyof typeof IUser.Type | undefined => {
  const user = getUser();
  return user?.type;
};

export const getUserIsImpersonating = (): boolean => {
  return !!getUser()?.impersonating;
};

export const getUserFirstName = (): string => {
  return getUser()?.first_name ?? "";
};
